import type * as Common from '@piccolohealth/pbs-common';
import { ChakraV3, createColumnHelper, DataTable, Empty } from '@piccolohealth/ui';
import React from 'react';
import { FaPlus } from 'react-icons/fa';
import { FormStack } from '../../../components/forms/FormStack';
import { showModal } from '../../../components/generic/Modal';
import { LabelCreateModal } from './LabelCreateModal';
import { LabelDeleteModal } from './LabelDeleteModal';
import { LabelUpdateModal } from './LabelUpdateModal';

interface Props {
  type: Common.LabelType;
  labels: Common.Label[];
}

export const LabelsForType = (props: Props) => {
  const { type, labels } = props;

  const columns = React.useMemo(() => {
    const columnHelper = createColumnHelper<Common.Label>();

    return [
      columnHelper.accessor('name', {
        header: 'Name',
        cell: (props) => (
          <ChakraV3.Tag colorPalette={props.row.original.color} size='sm'>
            {props.row.original.name}
          </ChakraV3.Tag>
        ),
      }),
      columnHelper.display({
        id: 'actions',
        header: 'Actions',
        cell: (props) => (
          <ChakraV3.HStack>
            <ChakraV3.Button
              onClick={() =>
                showModal(LabelUpdateModal, {
                  label: props.row.original,
                })
              }
              size='xs'
              variant='plain'
            >
              Edit
            </ChakraV3.Button>
            <ChakraV3.Button
              onClick={() =>
                showModal(LabelDeleteModal, {
                  labelId: props.row.original.id,
                  labelName: props.row.original.name,
                })
              }
              size='xs'
              variant='plain'
              color='red'
            >
              Delete
            </ChakraV3.Button>
          </ChakraV3.HStack>
        ),
      }),
    ];
  }, []);

  return (
    <FormStack gap={0} mb={6}>
      <DataTable
        columns={columns}
        data={labels}
        renderEmpty={() => <Empty title='No labels found' />}
        size='sm'
      />
      <ChakraV3.Button
        onClick={() =>
          showModal(LabelCreateModal, {
            type,
          })
        }
        flexShrink={0}
        size='sm'
        variant='subtle'
      >
        <FaPlus />
        Create new label
      </ChakraV3.Button>
    </FormStack>
  );
};
